var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"action-icon",attrs:{"href":"javascript: void(0);"},on:{"click":function($event){_vm.disabled ? 'return false;'  : _vm.$emit('onClick')}}},[(_vm.busy)?[_c('b-spinner',{attrs:{"small":""}})]:[_c('i',{staticClass:"fe-x-circle icon-blue"})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }